import api from '@/api'
import store from '@/store'

export default {
  paginate(page, perPage, keyword = '') {
    return new Promise(function(resolve, reject) {
      api
        .request('get', `/api/v1/companies?page=${page}&per_page=${perPage}&keyword=${keyword}`, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  getAllCompanies(force) {
    return new Promise(function(resolve, reject) {
      const cacheCompanyList = store.state.cache.companyList

      if (cacheCompanyList.data !== null && force === false) {
        resolve(cacheCompanyList)
      } else {
        api
          .request('get', '/api/v1/companies/all', true)
          .then(response => {
            if (response.status !== 200) {
              reject(response)
              return
            }

            // Save to Vuex store
            store.commit('SET_COMPANIES', response.data)

            resolve(store.state.cache.companyList)
          })
          .catch(error => {
            // Request failed.
            reject(error)
          })
      }
    })
  },
  getCompany(companyID) {
    return new Promise(function(resolve, reject) {
      api
        .request('get', '/api/v1/companies/' + companyID, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  createCompany(company) {
    return new Promise(function(resolve, reject) {
      api
        .request('post', '/api/v1/companies', true, company)
        .then(response => {
          if (response.status !== 201) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  editCompany(company) {
    const companyID = company.id
    delete company.id

    return new Promise(function(resolve, reject) {
      api
        .request('put', '/api/v1/companies/' + companyID, true, company)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  deleteCompany(companyID) {
    return new Promise(function(resolve, reject) {
      api
        .request('delete', '/api/v1/companies/' + companyID, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/views/Company/companyAPIs.js